function initFinishSlider() {

  const slider = document.querySelector('.finish-slider');
  const prev = document.querySelector('.finish-prev');
  const next = document.querySelector('.finish-next');

  if (!slider || !prev || !next) return;

  if (slider.dataset.initialized) return;

  slider.dataset.initialized = 'true';

  prev.addEventListener('click', () => {
    slider.scrollBy({
      left: -400,
      behavior: 'smooth'
    });
  });

  next.addEventListener('click', () => {
    slider.scrollBy({
      left: 400,
      behavior: 'smooth'
    });
  });

  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    startX = e.pageX;
    scrollLeft = slider.scrollLeft;
  });

  document.addEventListener('mouseup', () => {
    isDown = false;
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;

    e.preventDefault();

    const walk = (e.pageX - startX) * 1.5;

    slider.scrollLeft = scrollLeft - walk;
  });

}
document.addEventListener('DOMContentLoaded', function() {
  initFinishSlider();
});